import React from 'react';
import { View } from 'react-native';

import { HStack, VStack, theme } from '@squire/ui';

import { Skeleton } from '@/components/_shared/Skeleton';

import { styles } from './styles';

/**
 * Full-sheet loading skeleton for the Confirm Booking sheet. Shown while the
 * customer query is settling after sign-in so the user never sees the
 * signed-out → signed-in flip (SQR-12952). Mirrors the real sheet body layout.
 */
const ConfirmBookingSkeleton: React.FC = () => {
  return (
    <View testID="confirm-booking-skeleton">
      <VStack space={theme.spacing[5]} paddingVertical={theme.spacing[4]}>
        {/* Sign-in prompt line */}
        <Skeleton width="60%" height={16} />

        {/* Shop details: avatar + two lines */}
        <HStack space={theme.spacing[3]} centerVertical>
          <Skeleton variant="rectangular" width={48} height={48} />
          <VStack space={theme.spacing[2]}>
            <Skeleton width={220} height={14} />
            <Skeleton width={160} height={12} />
          </VStack>
        </HStack>

        {/* Payment method */}
        <VStack space={theme.spacing[3]}>
          <Skeleton width="40%" height={18} />
          <Skeleton width="100%" height={46} />
          <Skeleton width="100%" height={46} />
        </VStack>

        {/* Cancellation policy */}
        <Skeleton width="100%" height={40} />

        {/* Summary rows */}
        <VStack space={theme.spacing[2]}>
          <HStack style={styles.summaryRow}>
            <Skeleton width="30%" height={14} />
            <Skeleton width="15%" height={14} />
          </HStack>
          <HStack style={styles.summaryRow}>
            <Skeleton width="30%" height={14} />
            <Skeleton width="15%" height={14} />
          </HStack>
          <HStack style={styles.summaryRow}>
            <Skeleton width="35%" height={16} />
            <Skeleton width="20%" height={16} />
          </HStack>
        </VStack>

        {/* Book button */}
        <Skeleton width="100%" height={50} />
      </VStack>
    </View>
  );
};

ConfirmBookingSkeleton.displayName = 'ConfirmBookingSkeleton';
export { ConfirmBookingSkeleton };
